<template>
    <section class="w3l-contact-1 w3hny-form-btm py-5" id="contact">
        <div class="contacts-9 py-lg-5 py-md-4">
            <div class="container">
                <div class="header-sec text-center mb-5">
                    <br />
                    <h1 class="title-w3l">
                        Your Payment Has Been Received
                    </h1>
                </div>
                <div class="contactct-fm map-content-9">
                    <p>You will be redirected to the dashboard shortly.</p>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import Process from "../../Common/Common/Process";


onMounted(async () => {
    await Process.sleep(5000);
    await navigateTo("/dashboard", {replace: true});
})

useHead({
  //@ts-ignore
  title: `ForumLeadsFinder – Your payment has been received`,
  meta: [
    {
      name: "description",
      //@ts-ignore
      content: `ForumLeadsFinder - Thank you for purchasing tokens. You will be redirected shortly.`
    }
  ]
});
</script>

<style scoped></style>